import { styled } from 'styled-components';

import { useEffect, useRef, useState } from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { ReactComponent as iconLeft } from "../assets/icons/icon-arrow-left.svg";
import { ReactComponent as iconRight } from "../assets/icons/icon-arrow-right.svg";
import Swiper from 'react-id-swiper';

const Container = styled.div`
  display: flex;
  max-width: 100%;
  flex-direction: column;
  * {
    color: black;
  }
`;

const NavSection = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  border-top: 1px solid #969696;
  border-bottom: 1px solid #969696;
  z-index: 10;
`;

const RowBox = styled.div`
  display: flex;
  width: 80%;
  height: 40px;
  overflow: hidden;
`;

const NavBox = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
`;

const SwiperContainer = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const YearSwiper = styled.div<{ width: string, $move?: number }>`
  position: sticky;
  top: 40px;
  width: ${(props) => props.width};
  max-height: calc(100vh - 130px);
  overflow: hidden;
  // background: #27C4D555;

  // transform: translateY(-${(props)=>props.$move}px);
  // transition: transform 0.5s ease-in-out;

  .swiper-container {
    width: 100%;
    height: calc(100vh - 130px);
  }
`;

const DataSwiper = styled.div<{ width: string }>`
&::-webkit-scrollbar {
  display: none;
}
  width: ${(props) => props.width};
  overflow-y: scroll;
`;

const StyledSlide = styled.div<{ type: string, $isselect: string }>`
  width: 100%;
  height: 100%;
  margin: ${(props) => props.type === "year" ? "50px 0" : 0};
  padding: ${(props) => props.type === "year" ? 0 : "50px 0"};
  padding-right: ${(props) => props.type === "year" ? "10%" : "15%"};
  text-align: ${(props) => props.type === "year" ? "right" : "center"};
  font-family: 'NumFont';
  font-size: ${(props) => props.type === "year" ? "13vw" : "2vw"};
  font-weight: ${(props) => props.type === "year" ? "500" : "400"};
  color: ${(props) => props.$isselect === "true" ? 
    props.type === "year" ? "#27C4D5" : "#121212"
    : "#EFEFEF"
  };

  display: flex;
  justify-content: ${(props) => props.type === "year" ? "end" : "start"};
  align-items: center;

  h1, h2, h3, p, pre, span {
    font-family: 'TbellFont';
    color: ${(props) => props.$isselect === "true" ? "#121212" : "#EFEFEF"};
  }
`;

const NavButton = styled.button<{ $isselect: string }>`
  background: none;  
  // margin: 0 5%;
  width: 20%;
  // min-width: 20%;
  color: ${(props) => props.$isselect === "true" ? "#333333" : "#979797"};
  font-weight: ${(props) => props.$isselect === "true" ? "600" : "400"};
  border-bottom: ${(props) => props.$isselect === "true" ? "2px solid #27C4D5" : "none"};
  &:hover {
    background: none;
    color: ${(props) => props.$isselect === "true" ? "#333333" : "#27C4D5"};
  }
`;

const ArrowLeft = styled(iconLeft)`
  flex: 1;
  width: auto;
  height: 50%;
  cursor: pointer;
  fill: #121212;
  stroke: #121212;
  margin: 0 3vw;
  &:hover {
    fill: #27C4D5;
    stroke: #27C4D5;
  }
`;

const ArrowRight = styled(iconRight)`
  flex: 1;
  width: auto;
  height: 50%;
  cursor: pointer;
  fill: #121212;
  stroke: #121212;
  margin: 0 50px;
  &:hover {
    fill: #27C4D5;
    stroke: #27C4D5;
  }
`;

const WheelScrollSection2 = ({
  years,
  datas,
  history,
}) => {
  const [yearId, setYearId] = useState<number>(0);
  const historyRef = useRef(null);
  const swiperRef = useRef(null);

  const slideTo = (index) => {
    // console.log(index);
    if(index < 0 || index > years.length - 1) return;
    const movePage = moveToTargetPage(index);
    movePage();
    // setYearId(index);
  };

  useEffect(() => {
    if(swiperRef.current && swiperRef.current.swiper)
      swiperRef.current.swiper.slideTo(yearId);
  }, [yearId]);

  const params = {
    slidesPerView: 3,
    centeredSlides: true,
    // spaceBetween: 30,
    direction: "vertical",
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    allowTouchMove: false,
    on: {
    },
  };

  const pageRef = useRef<HTMLDivElement[]>([]);

  const moveToTargetPage = (index: number) => () => {
    // console.log("index: ",index);
    if(pageRef.current){
      for (const item of pageRef.current) {
        const id = item.className.split("year")[1];
        // console.log("id: ",id);
        if(parseInt(id) === index) {
          item.scrollIntoView({
            block:'start',
            behavior:"smooth",
            inline:'center'
          });
          break;
        }
      }
    }
  };
 

  const options:IntersectionObserverInit = {
    root: document.getElementById("data-sec"),
    rootMargin: '-10% 0px -80% 0px',
    threshold: 0
  }
  const callback:IntersectionObserverCallback = (entries:IntersectionObserverEntry[],observer) => {
    // console.log(entries);
    entries.forEach((entry) => {
      const {
        isIntersecting, 
        boundingClientRect,
        target
      } = entry;
      // pageYOffset 문서가 수직으로 얼마나 스크롤 됐는지 픽셀 단위로 반환한다.
      // const scrollTop = document.getElementById("main").scrollTop;

      // 이벤트가 발생된 target의 height
      // const {height} = boundingClientRect;

      // 관찰 요소와 교차될때마다 index를 계산하여 viewIndex의 값을 바꿔준다.
      const id = target.className.split("year")[1];
      const index = parseInt(id);

      if(isIntersecting) {
        // const index = Math.round(scrollTop / height);
        setYearId(index);
      }
    });
  };
  
  const io = new IntersectionObserver(callback,options);

  useEffect(() => {
    // 첫 랜더링때에만 io를 부착한다
    // pageRef.current!.forEach((item) => io.observe(item));
    
    // clean-up function. componentDidMount 이후 실행된다.
    return () => {
      pageRef.current!.forEach((item) => io.unobserve(item));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const [isFirst, setIsFirst] = useState<boolean>(true);

  useEffect(() => {
    if(pageRef && pageRef.current && pageRef.current.length > 0 && isFirst) {
      pageRef.current!.forEach((item) => io.observe(item));
      setIsFirst(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageRef.current]);

  const addRef = (element: HTMLDivElement) => {
    pageRef.current = [...pageRef.current, element];
  };

  return (
    <Container ref={historyRef} id={"history"}>
      <Box display={"flex"} w={"100%"} h={"70px"} justifyContent={"center"} padding={"10px"} mb={"20px"}>
        <Heading as={"h3"} color={"#121212"} h={"70px"}>연혁</Heading>
      </Box>
      <NavSection>
        <ArrowLeft onClick={() => slideTo(yearId - 1)}/>
        <RowBox>
          <NavBox>
            {years?.map((item, index) => {
              return(
                <NavButton 
                  key={index} 
                  id={`nav${index}`}
                  className='nav' 
                  $isselect={(yearId === index).toString()} 
                  onClick={moveToTargetPage(index)}
                >
                  {item}
                </NavButton>
              )
            })}
          </NavBox>
        </RowBox>
        <ArrowRight onClick={() => slideTo(yearId + 1)}/>
      </NavSection>
      <SwiperContainer id={"wheel-sec"}>
        <YearSwiper width={"40%"}>
          <Swiper {...params} ref={swiperRef}>
          {years?.map((item, index) => {
            return (              
              <StyledSlide 
                key={index} 
                id={`year${years[index]}`}
                className='year'
                type={"year"}
                $isselect={(yearId === index).toString()}
                style={{ maxHeight: "calc(((100vh - 130px) / 3) - 50px)"}}
              >
                {item}
              </StyledSlide>              
            )
          })}
          </Swiper>
        </YearSwiper>
        <DataSwiper
          id={"data-sec"}
          width={"60%"}
          className='history-data'
          onScroll={() => {}}
        >
          <Box w={"100%"} h={`calc(50vh - 130px - 50px)`}></Box>
          {history?.map((h, hId) => {
            return (
              <div 
                key={hId} 
                className={`year${hId}`} 
                // ref={(r) => r && addRef(r)}
                ref={(r) => { 
                  if(r && pageRef.current)
                    return pageRef.current[hId] = r 
                }}
              >
                {h.datas?.map((item, index) => {
                  return(
                    <StyledSlide 
                      key={index}
                      id={`data${index}`} 
                      className={`data`}
                      type={"data"} 
                      $isselect={(yearId === hId).toString()}
                    >
                      <Box display={"flex"} w={"100%"} h={"100%"} flexDir={"column"} alignItems={"start"} justifyContent={"center"} borderBottom={"1px solid #969696"} pb={"20px"}>
                        <Heading 
                          w={"80%"} 
                          as={"h3"} 
                          textAlign={"left"} 
                          fontWeight={600} 
                          borderBottom={"1px solid #969696"}
                          lineHeight={"220%"}
                          mb={"20px"}
                        >
                          {item.title && item.title !== "" ? item.title : item.month + "월"}
                        </Heading>
                        {item.desc?.map((desc, i) => {
                          return (
                            <Text key={i} textAlign={"left"} whiteSpace={"pre-wrap"} fontSize={"18px"} lineHeight={"220%"}>{desc}</Text>
                          )
                        })}
                      </Box>
                    </StyledSlide>
                  )
                })}
              </div>
            )
          })}
          {/* {datas?.map((item, index) => {
            return(
              <StyledSlide 
                key={index}
                id={`data${index}`} 
                className={`data year${item.year}`}
                type={"data"} 
                $isselect={(years[yearId] === item.year).toString()}
                // ref={(r) =>{ if(r && pageRef.current) return pageRef.current[index] = r}}
                ref={(r) => r && addRef(r)}

              >
                <Box display={"flex"} w={"100%"} h={"100%"} flexDir={"column"} alignItems={"start"} justifyContent={"center"}>
                  <Heading 
                    w={"80%"} 
                    as={"h3"} 
                    textAlign={"left"} 
                    fontWeight={600} 
                    borderBottom={"1px solid #969696"}
                    mb={"20px"}
                  >
                    {item.title && item.title !== "" ? item.title : item.month + "월"}
                  </Heading>
                  {item.desc?.map((desc, i) => {
                    return (
                      <Text key={i} textAlign={"left"} whiteSpace={"pre-wrap"} fontSize={"18px"}>{desc}</Text>
                    )
                  })}
                </Box>
              </StyledSlide>
            )
          })} */}
          <Box w={"100%"} h={`calc(50vh - 130px - 50px)`}></Box>
        </DataSwiper>
      </SwiperContainer>

    </Container>
  );
};

export default WheelScrollSection2;